/**
 * Checks for intersection of a `Range` object with `mark` or `a` elements in a specified container {@link containerId}.
 *
 * @param {Range} range - The `Range` object to test for intersection.
 * @param {string} containerId - The container the range should be in, used to look for existing intersecting elements.
 * @param {'mark' | 'a'} tagName - The tag name of the element to test for intersection.
 * @returns {boolean} Indicates whether an intersection was detected.
 */
function testForIntersection(
  range: Range,
  containerId: string,
  tagName: 'mark' | 'a',
): boolean {
  const rootEl: Element | null | undefined =
    document.getElementById(containerId);
  const elements = rootEl?.getElementsByTagName(tagName);
  let intersectionDetected = false;

  if (!elements) {
    return intersectionDetected;
  }

  // find all link or mark elements within the root container
  // check if the new mark/link (represented by the range) would overlap with existing mark(s)/link(s)
  const elementsArr = Array.from(elements);
  elementsArr.forEach((el) => {
    if (range.intersectsNode(el)) {
      intersectionDetected = true;
    }
  });

  return intersectionDetected;
}

export default testForIntersection;
